import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const DashboardAtendimento = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://fsys.app.br/5dx/nps_relatorio.php');
        if (!response.ok) throw new Error(`Erro HTTP: ${response.status}`);
        const result = await response.json();
        setDashboardData(result);
      } catch (err) {
        setError(err.message);
        console.error('Erro ao buscar dados:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8'];

  if (loading) return <div className="loading">Carregando dados...</div>;
  if (error) return <div className="error">Erro: {error}</div>;
  if (!dashboardData) return <div>Nenhum dado disponível</div>;

  return (
    <div className="dashboard-container">
      <h1>Relatórios de Atendimento</h1>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>Pesquisas Respondidas</h3>
          <p>{dashboardData.total_pesquisas}</p>
        </div>
        <div className="stat-card">
          <h3>Média Geral NPS</h3>
          <p>{dashboardData.media_nps.toFixed(1)}</p>
        </div>
        <div className="stat-card">
          <h3>Média Produto</h3>
          <p>{dashboardData.media_produto.toFixed(1)}</p>
        </div>
        <div className="stat-card">
          <h3>Média Preços</h3>
          <p>{dashboardData.media_precos.toFixed(1)}</p>
        </div>
        <div className="stat-card">
          <h3>Média Promoções</h3>
          <p>{dashboardData.media_promocoes.toFixed(1)}</p>
        </div>
        <div className="stat-card">
          <h3>Média Atendimento</h3>
          <p>{dashboardData.media_atendimento.toFixed(1)}</p>
        </div>
      </div>

      <div className="chart-container">
        <h2>Distribuição das Avaliações por Fator</h2>
        <div style={{ width: '100%', height: 400 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={dashboardData.grafico_campos}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={150}
                fill="#8884d8"
                dataKey="percentual"
                nameKey="campo"
                label={({ campo, percentual }) => `${campo}: ${percentual.toFixed(1)}%`}
              >
                {dashboardData.grafico_campos.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value, name) => [`${value}%`, name]} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DashboardAtendimento;
